import debounce from 'lodash/debounce';

/**
 * Alias to Lodash debounce
 * @function
 * @see https://lodash.com/docs#debounce
 */
export default debounce;